import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackContentView } from './barionPixel';

/**
 * Fires a Barion `contentView` event on every SPA route change.
 *
 * Mount once near the top of the React tree (e.g. inside <App/>, *inside*
 * BrowserRouter so that `useLocation()` is available).
 */
const useBarionPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    trackContentView({
      contentType: 'Page',
      path,
    });
  }, [location.pathname, location.search]);
};

export default useBarionPageTracking;
